import { CheckCircleOutlined, ErrorOutline, InfoOutlined } from '@mui/icons-material';
import { SvgIconTypeMap, Tooltip } from '@mui/material';
import { ElementType, ReactNode } from 'react';

import { CuriosityTranslationValue } from './TransCuriosityLookup/TransCuriosityLookup.types';

export const createSlotProps = (virtual?: boolean) => ({
  primary: virtual ? { noWrap: true } : undefined,
  secondary: virtual ? { noWrap: true } : undefined,
});

export const levelMap: Record<string, { icon: ElementType; color?: SvgIconTypeMap['props']['color'] }> = {
  ERROR: { icon: ErrorOutline, color: 'error' },
  WARNING: { icon: ErrorOutline, color: 'error' },
  NEUTRAL: { icon: InfoOutlined },
  SUCCESS: { icon: CheckCircleOutlined, color: 'success' },
} as const;

export const getActorName = (value: CuriosityTranslationValue) => {
  const fullName = value?.entity ? `${value.entity.firstName} ${value.entity.lastName}` : '';

  if (value?.entity?.email) {
    return (
      <Tooltip title={value.entity.email} arrow placement="top">
        <span style={{ cursor: 'help' }}>{fullName}</span>
      </Tooltip>
    );
  }

  return fullName;
};

export const getMessage = (virtual: boolean | undefined, message: ReactNode) => {
  return virtual ? (
    <Tooltip title={message} placement="bottom-start">
      <span>{message}</span>
    </Tooltip>
  ) : (
    message
  );
};
